module.exports = __webpack_public_path__ + "img/sorry.007129b5.svg";